import React from "react";
import { ClockCircleOutlined, RightOutlined, WarningOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import "./TasksCard.less";

const TasksCard = ({ overdueCount, pendingTodayCount, onViewTasks, disabled = false }) => {
  const { t } = useTranslation();

  const handleClick = (e) => {
    e.stopPropagation();
    if (!disabled) {
      onViewTasks?.();
    }
  };

  // Don't render if no tasks
  if (overdueCount === 0 && pendingTodayCount === 0) {
    return null;
  }

  return (
    <div className={`tasks-card ${disabled ? "tasks-card-disabled" : ""}`}>
      <div className="tasks-card-header">
        <ClockCircleOutlined className="tasks-card-header-icon" />
        <span className="tasks-card-header-title">{t("pending_actions.tasks_card.title", "Tasks")}</span>
      </div>

      <div className="tasks-card-rows">
        {overdueCount > 0 && (
          <div className="tasks-card-row tasks-card-row-overdue" onClick={handleClick}>
            <div className="tasks-card-row-icon overdue">
              <WarningOutlined />
            </div>
            <div className="tasks-card-row-content">
              <div className="tasks-card-row-title">{t("pending_actions.tasks_card.overdue", "Overdue")}</div>
              <div className="tasks-card-row-description">
                {t("pending_actions.tasks_card.overdue_desc", "Tasks past due date")}
              </div>
            </div>
            <div className="tasks-card-row-badge overdue">{overdueCount}</div>
            <RightOutlined className="tasks-card-row-arrow" />
          </div>
        )}

        {pendingTodayCount > 0 && (
          <div className="tasks-card-row tasks-card-row-today" onClick={handleClick}>
            <div className="tasks-card-row-icon today">
              <CheckCircleOutlined />
            </div>
            <div className="tasks-card-row-content">
              <div className="tasks-card-row-title">
                {t("pending_actions.tasks_card.pending_today", "Pending Today")}
              </div>
              <div className="tasks-card-row-description">
                {t("pending_actions.tasks_card.today_desc", "Due today")}
              </div>
            </div>
            <div className="tasks-card-row-badge today">{pendingTodayCount}</div>
            <RightOutlined className="tasks-card-row-arrow" />
          </div>
        )}
      </div>
    </div>
  );
};

export default TasksCard;
